module.exports = __webpack_public_path__ + "static/media/knex.dd2bd348.png";